<header class="modal-header">
  <h5>Server Error</h5>
</header>
<section class="modal-body">
  <p class="text-center">Sorry, there has been an issue with the server.</p>
</section>
<footer class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="refresh()">Retry</button>
</footer>
